<template>
    <v-list dense>
      <v-subheader>{{ title }}</v-subheader>
        <v-list-item v-for="item in items" :key="item.id" @click="applyFilter(item.id)">
            <v-list-item-action v-if="activeItem === item.id">
              <v-icon>mdi-check</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
export default {
    name: "SideFilter",
    data: () => ({
        activeItem: 0
    }),
    props: ["title", "model"],
    computed: {
        modelName: function() {
            return _.startCase(this.model);
        },
        items: function() {
            return this.$store.getters["list" + this.modelName];
        }
    },
    methods: {
        applyFilter(value) {
            this.activeItem = (this.activeItem === value) ? 0 : value;
            this.$store.commit("dofilter", {key: this.model, value: value});
        }
    },
    mounted() {
        this.$store.dispatch("find" + this.modelName);
    },
}
</script>